import { Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { BehaviorSubject, Observable } from "rxjs";

import { MapOperation } from "@app/interface/gisinterface/map-operation";
import { RouteExtent } from "@app/interface/gisinterface/route-extent";
import { SidePanel } from "@app/interface/gisinterface/side-panel";
import { ProblemGetModel, ProblemPostModel } from "@app/models/failure/problem.model";
import { PlaceMileageModel } from "@app/models/failure/master.model";
import { AdvanceSearchModel } from "@app/models/gismodel/advance-search.model";
import { LayerDisciplineModel, LayerModel } from "@app/models/gismodel/layer.model";
@Injectable({ providedIn: 'root' })
export class GisSharedService {

    private globalFaultId: number;
    setFaultId(faultId: number) { this.globalFaultId = faultId; }
    getFaultId(): number { return this.globalFaultId; }

    private globalFaultCode: string;
    setFaultCode(faultCode: string) { this.globalFaultCode = faultCode; }
    getFaultCode(): string { return this.globalFaultCode; }

    private mapOperation: MapOperation;
    setMapOperation(mapOperation: MapOperation) { this.mapOperation = mapOperation; }
    getMapOperation(): MapOperation { return this.mapOperation; }

    private routeExtent: RouteExtent[] = [];
    setRouteExtent(routeExtent: RouteExtent) { this.routeExtent.push(routeExtent); }
    getRouteExtent(ifcId: number): RouteExtent {
        let routeExtent = this.routeExtent.filter(r => r.ifcId == ifcId);
        if (routeExtent && routeExtent.length > 0) return routeExtent[0];
        return undefined;
    }

    private layerList = new BehaviorSubject<LayerModel[]>([]);
    setLayerList(layer: LayerModel[]) { this.layerList.next(layer); }

    currentLayerList = this.layerList;
    getLayerList(): Observable<LayerModel[]> { return this.currentLayerList; }

    private modelPanelAssets: any[];
    setPanelAssets(modelPanelAssets: any[]) { this.modelPanelAssets = modelPanelAssets; }
    getPanelAssets(): any[] { return this.modelPanelAssets; }

    sidePanel: BehaviorSubject<SidePanel> = new BehaviorSubject(null);
    setSidePanel(sidePanel: SidePanel) {
        if (sidePanel && (sidePanel.history == undefined)) sidePanel.history = [];
        this.sidePanel.next(sidePanel);
    }
    getSidePanel(): Observable<SidePanel> { return this.sidePanel; }

    private modelAdvancedSearch: AdvanceSearchModel = new AdvanceSearchModel();
    setAdvancedSearchData(modelAdvancedSearch: AdvanceSearchModel) {
        this.modelAdvancedSearch = modelAdvancedSearch;
    }
    getAdvancedSearchData(): AdvanceSearchModel { return this.modelAdvancedSearch; }

    private modelPostFaults: ProblemPostModel = new ProblemPostModel();
    setModelPostFault(modelPostFaults: ProblemPostModel) { this.modelPostFaults = modelPostFaults }
    getModelPostFault(): ProblemPostModel { return this.modelPostFaults; }
    
    private modelGetFault: ProblemGetModel = new ProblemGetModel();
    setModelGetFault(modelGetFault: ProblemGetModel) { this.modelGetFault = modelGetFault }
    getModelGetFault(): ProblemGetModel { return this.modelGetFault; }

    private reporterDetails: FormGroup;
    setReporterDetails(reporterDetails: FormGroup) { this.reporterDetails = reporterDetails }
    getReporterDetails(): FormGroup { return this.reporterDetails; }

    private reportedDetails: FormGroup;
    setReportedDetails(reportedDetails: FormGroup) { this.reportedDetails = reportedDetails }
    getReportedDetails(): FormGroup { return this.reportedDetails; }

    private failureRiskPriority: FormGroup;
    setFailureRiskPriority(failureRiskPriority: FormGroup) { this.failureRiskPriority = failureRiskPriority }
    getFailureRiskPriority(): FormGroup { return this.failureRiskPriority; }

    private failureType: string = '';
    setFailureType(failureType: string) { this.failureType = failureType; }
    getFailureType(): string { return this.failureType; }

    resetMapSession() {
        this.setFaultId(undefined);
        this.setFaultCode(undefined);
        this.setMapOperation(undefined);
        this.setPanelAssets(undefined);
        this.setFailureType(undefined);
        this.setReporterDetails(undefined);
        this.setFailureRiskPriority(undefined);
        this.setReportedDetails(undefined);
    }

    private mapAdvancedSearchForm: FormGroup;
    setMapAdvancedSearch(searchForm) { this.mapAdvancedSearchForm = searchForm; }
    getMapAdvancedSearch(): FormGroup { return this.mapAdvancedSearchForm; }

    private modelPlaceMileage: PlaceMileageModel;
    setPlaceMileage(modelPlaceMileage: PlaceMileageModel) { this.modelPlaceMileage = modelPlaceMileage; }
    getPlaceMileage(): PlaceMileageModel { return this.modelPlaceMileage; }

    private assignmentData: FormGroup;
    setAssignmentData(assignmentData: FormGroup) { this.assignmentData = assignmentData; }
    getAssignmentData(): FormGroup { return this.assignmentData; }
}